export const getNlisHoldings = (
  state: RootState,
): StateModelById<NlisHolding> => state.nlisFiles.holdings.byId;

export const getIsFetchingNlisHoldings = (state: RootState): boolean =>
  state.nlisFiles.holdings.isFetching;
